module.exports = __webpack_public_path__ + "img/home2.72813b7f.png";